import { useContext } from "react";
import UserDataPreferenceForm from "../UserDataPreferenceForm";
import { UserDataPreferenceContext } from "..";
import Styles from '../Styles.module.css'

export default function CallDistributionOptOutView(){
  const { setTitle } = useContext(UserDataPreferenceContext);
  setTitle("Consumer Call Center Data - Opt-Out of Voice Biometric Data for AI Training Purposes")

  return (
    <>
      <p>
        To opt-out of CURE sharing voice biometric data with third parties for AI training purposes, please enter your first name, 
        last name and the phone number from which you called CURE and click submit.
      </p>
      <p>
        For more information about our Privacy Notice, <a href="/privacy-policy" className={Styles.link}>click here</a>.
      </p>
      <h5 style={{marginBottom: "5px"}}>Caller Information</h5>
      <UserDataPreferenceForm 
        successMessage={"You have been opted-out. Thank you."} 
        dataType="Call Distribution" 
        status="Opt Out"
      />
      <p>Previously opted-out and would like to opt-in? <a href="/optout?v=call-dist-opt-in" className={Styles.link}>Click here to opt-in to voice biometric data for AI training purposes.</a></p>
      <p>Not a resident of New Jersey, Pennsylvania, or Michigan? <a href="/optout?v=targeted-ads-opt-out" className={Styles.link}>Click here to opt-out of targeted advertising.</a></p>
    </>
  )
}